import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import { getAudioFileUrl } from '@culture/utils/helpers/files';
import _ from 'underscore';
import cx from 'classnames';
import AudioPlayer from 'components/Audio/AudioPlayer';

import { MaterialPropType } from 'propTypes/common';
import styles from './styles.module.scss';

const { publicRuntimeConfig } = getConfig();

const Audio = (props) => {
	let trackUrl;

	if (props.isInteractive && !_.isEmpty(props.audio)) {
		trackUrl =
			typeof props.audio === 'string'
				? props.audio
				: getAudioFileUrl(props.audio, {
						config: publicRuntimeConfig
				  });
	}

	if (!_.isEmpty(props?.material?.files)) {
		trackUrl = getAudioFileUrl(props?.material?.files[0], {
			config: publicRuntimeConfig
		});
	}

	return (
		!!trackUrl && (
			<AudioPlayer
				trackSrc={trackUrl}
				className={cx(
					styles.audioTrackContainer,
					props?.isInteractive && styles.audioTrackContainer_isInteractive
				)}
			/>
		)
	);
};

Audio.propTypes = {
	material: MaterialPropType,
	audio: PropTypes.object,
	isInteractive: PropTypes.bool
};

export default Audio;
